import { QuoteProMergeDataset } from '../../datasets/quote.pro.merge.dataset';
import { FakeAccountContactMergeData } from '../data/fake.account.contact.merge.data';
import { FakeAccountMergeData } from '../data/fake.account.merge.data';
import { FakeCompanyMergeData } from '../data/fake.company.merge.data';
import { FakeEmployeeMergeData } from '../data/fake.employee.merge.data';
import { FakeQuoteProMergeData, FakeQuoteProSiteMergeData } from '../data/fake.quote.pro.merge.data';


export class FakeQuoteProMergeDataset extends QuoteProMergeDataset {

    constructor(baseUrl: string = '') {
        super();

        this.quoteCompany = new FakeCompanyMergeData(baseUrl);
        this.quoteAccount = new FakeAccountMergeData();
        this.quoteContact = new FakeAccountContactMergeData();
        this.quoteOwner = new FakeEmployeeMergeData();
        this.quoteSite = new FakeQuoteProSiteMergeData();

        this.quote = new FakeQuoteProMergeData();


    }

}